export default function (href = '') {
    const link = document.querySelector("link[rel~='icon']")
    link && link.setAttribute('href', href)
}
